import { Tag } from "@canopyinc/aura";

export const ClosedLoanTag = () => {
  return (
    <Tag color="green" size="sm">
      Closed
    </Tag>
  );
};
